import {SeeMoreReviewsClickEvent} from '@/features/course-landing-page/events/events';
import {publishEvent} from '@udemy-v2/event-tracking';
import {useI18n} from '@udemy-v2/i18n';
import {Button} from '@udemy-v2/react-core-components';
import classNames from 'classnames';
import styles from './reviews-modal-button.module.scss';

interface ReviewsModalButtonProps {
    frontendTrackingId?: string;
    reviewableObjectId: number;
    reviewableObjectType: string;
    label?: string;
    className?: string;
    fullWidth?: boolean;
    udStyle?: 'secondary' | 'ghost';
    onClick: () => void;
}

export const ReviewsModalButton = ({
    frontendTrackingId,
    reviewableObjectId,
    reviewableObjectType,
    label = 'Show all reviews',
    className,
    fullWidth = true,
    udStyle = 'secondary',
    onClick,
}: ReviewsModalButtonProps) => {
    const {gettext} = useI18n();

    const trackSeeMoreReviewsClick = () => {
        if (frontendTrackingId) {
            publishEvent(
                new SeeMoreReviewsClickEvent({
                    courseTrackingId: frontendTrackingId,
                    reviewableObjectId,
                    reviewableObjectType,
                }),
            );
        }
    };

    const handleOnButtonClick = () => {
        trackSeeMoreReviewsClick();
        onClick();
    };

    return (
        <Button
            onClick={handleOnButtonClick}
            data-purpose="show-reviews-modal-trigger-button"
            size="medium"
            udStyle={udStyle}
            className={classNames(className, {
                'ud-link-underline': udStyle === 'ghost',
                [styles['full-width-button']]: fullWidth,
            })}
        >
            {gettext(label)}
        </Button>
    );
};
